<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <div class="table-responsive" style="max-width: 98%;
      margin-left: 1%;" *ngIf="!!users">
        <table id=" " class="table table-insurance-inner " style="margin-top: 20px">
          <thead>
            <tr>
              <th class="wd-15p th-pd">User Name</th>
              <th class="wd-15p th-pd">First Name</th>
              <th class="wd-30p th-pd">Last Name</th>
              <th class="wd-30p th-pd">Active</th>
              <th class="wd-5p th-pd">GPS Enabled</th>
              <th class="wd-15p th-pd">WEB Enabled</th>
              <th class="wd-15p th-pd">Tenant</th>
              <th class="wd-15p th-pd">Role</th>
              <th class="wd-15p th-pd">Actions</th>
              <th class="wd-15p th-pd">Roles</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of users.users; let count = index">
            <tr class="">
              <td>{{item.email}}</td>
              <td>{{item.firstName}}</td>
              <td>{{item.lastName}}</td>
              <td><i *ngIf="item.active" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.active"
                  style="color: #cc2929" class="fa fa-close"></i></td>
              <td><i *ngIf="item.gpsEnabled" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.gpsEnabled"
                  style="color: #cc2929" class="fa fa-close"></i></td>
              <td><i *ngIf="item.webEnabled" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.webEnabled"
                  style="color: #cc2929" class="fa fa-close"></i></td>
              <td>{{item?.tenant?.tenantName}}</td>
              <td>{{item?.role?.role}}</td>
              <td>
                <a href="javascript:void(0)"><i class="fa fa-pencil drug-ins-action" aria-hidden="true"
                    data-toggle="modal" data-target="#addUserSelector" (click)="editUser(item)"></i></a>
                <a href="javascript:void(0)" data-toggle="modal" data-target="#deleteConfirmation"
                  style="margin-left: 6px;"><i style="color: #c73131" class="fa fa-trash drug-ins-action"
                    aria-hidden="true" (click)="selectRecord(item)"></i></a>
              </td>
              <td>
                <button class="btn btn-primary" type="button" style="padding: 2px 13px 2px 12px; 
                font-size: 12px; background-color: #195698;"
                  (click)="selectedIndex = count; fetchSecuritySpecs(item)">Access</button>
              </td>
            </tr>
            <tr *ngIf="selectedIndex == count" style="background: #f9f9f9;
              border-bottom: 1px solid #dadada;">
              <td colspan="10">
                <div class="row access-block">
                  <div class="col-6 ">
                    <h6>Access Specs </h6>
                    <span>User {{selectedUser?.email}} Has access to the following security</span>
                    <div class="row container" style="margin-top: 20px">
                      <div tooltip="{{securitySpec?.userModule?.description}}" placement="top" show-delay="500"
                        class="col-2 user-spec" *ngFor="let securitySpec of securitySpecs">
                        {{securitySpec?.userModule?.moduleName}}
                        <i style="color: #dc3545; cursor: pointer;" (click)="deleteUserModule(securitySpec)"
                          class="fa fa-close text-right pull-right"></i>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 row" style="margin-top: 31px;">
                    <div class="col-8">
                      <ngx-select-dropdown [config]="moduleFilterConfig" [options]="unselectedModules"
                        [(ngModel)]="selectedModules" [multiple]="true"></ngx-select-dropdown>
                    </div>
                    <div class="col-2" style="margin-top: 3px">
                      <button class="btn btn-primary" style="padding: 2px 13px 2px 12px; 
                      font-size: 12px; background-color: #195698;" (click)="addUserModule()"> <i class="fa fa-plus"></i> Add Module(s) </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<button class="btn-floating-action" data-toggle="modal" data-target="#addUserSelector" (click)="setUserObj();">
  <span class="fa fa-plus"></span>
  <span class="action-tooltip text-500">Add User</span>
</button>


<div class="modal fade" id="addUserSelector" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document" style="min-width: 120vh;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{isEdituser ? 'Edit': 'Add'}} User</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">

            <div class="row form-group">
              <div class="col-md-3">
                <label>User Id</label>
              </div>
              <div class="col-md-9">
                <input type="text" class="form-control" [(ngModel)]="dataObj.email" />
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-3">
                <label>First Name</label>
              </div>
              <div class="col-md-9">
                <input type="text" class="form-control" [(ngModel)]="dataObj.firstName" />
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-3">
                <label>Last Name</label>
              </div>
              <div class="col-md-9">
                <input type="text" class="form-control" [(ngModel)]="dataObj.lastName" />
              </div>
            </div>


            <div class="row form-group">
              <div class="col-md-12">
                <div class="nurse_input past_input systemic_in">
                  <input type="checkbox" id="eh0000-option" name="selector_h" [(ngModel)]="dataObj.active" />
                  <label for="eh0000-option">&nbsp;&nbsp;&nbsp;Active</label>
                </div>
              </div>

              <div>
                <div class="col-md-12">
                  <div class="nurse_input past_input systemic_in">
                    <input type="checkbox" id="eh0000-option-web" name="selector_hweb"
                      [(ngModel)]="dataObj.webEnabled" />
                    <label for="eh0000-option-web">&nbsp;&nbsp;&nbsp;Web Enabled</label>
                  </div>
                </div>
              </div>

            </div>


          </div>


          <div class="col-md-6">

            <div class="row form-group">
              <div class="col-md-3">
                <label>Tenant</label>
              </div>
              <div class="col-md-9">
                <select [(ngModel)]="dataObj.tenant" class="form-control" [compareWith]="byId">
                  <option *ngFor="let tenant of users?users.tenants:''" [ngValue]="tenant">
                    {{tenant ? tenant.tenantId: ''}} : {{tenant ? tenant.tenantName : ''}}</option>
                </select>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-3">
                <label>Role</label>
              </div>
              <div class="col-md-9">
                <select [(ngModel)]="dataObj.role" class="form-control" [compareWith]="byRoleId">
                  <option *ngFor="let role of users?users.roles:[]" [ngValue]="role">
                    {{role ? role.roleId: ''}} : {{role.role}}
                  </option>
                </select>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-3">
                <label>Password</label>
              </div>
              <div class="col-md-9">
                <input type="password" class="form-control" [(ngModel)]="dataObj.password" />
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-12">
                <div class="nurse_input past_input systemic_in">
                  <input type="checkbox" id="eh0000-option-gps" name="selector_h_gps"
                    [(ngModel)]="dataObj.gpsEnabled" />
                  <label for="eh0000-option-gps">&nbsp;&nbsp;&nbsp;GPS Enabled</label>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveUserDetails()">Save</button>

          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>

  </div>

</div>


<div class="modal fade" id="deleteConfirmation" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Delete Confirmation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <span style="margin-left: 20px;">Are you sure you want to delete {{selectedUser?.email}} ?</span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="deleteUser()">Delete</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>

      </div>
    </div>
  </div>

</div>